import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import Tab from './Tab';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: ${theme.spaces.small}px;

  @media ${theme.devices.tablet} {
    gap: ${theme.spaces.smallX}px;
  }
`;

const Tabs = ({ color, selected, items = [], onSelect }) => (
  <StyledContainer>
    {items.map((item) => (
      <Tab key={item.tabId} color={color} selected={selected} onSelect={onSelect} {...item} />
    ))}
  </StyledContainer>
);

Tabs.propTypes = {
  color: PropTypes.string,
  selected: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      tabId: PropTypes.string,
      iconAlias: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  onSelect: PropTypes.func,
};

export default Tabs;
